const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';
const isFunction = (fn) => Object.prototype.toString.call(fn) === '[object Function]';

// url拼接
const handleParams = (obj) => {
    let result = '';
    for (const item in obj) {
        if (obj[item]) {
            if (obj[item] instanceof Array) {
                obj[item].map((it) => {
                    result += `&${item}=${it}`;
                });
            } else {
                result += `&${item}=${obj[item]}`;
            }
        }
    }
    if (result) {
        result = `?${result.slice(1)}`;
    }
    return result;
};

// 深拷贝
const deepClone = (obj) => {
    // 判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
    const objClone = Array.isArray(obj) ? [] : {};
    // 进行深拷贝的不能为空，并且是对象或者是
    if (obj && typeof obj === 'object') {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] && typeof obj[key] === 'object') {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
};

// 浅拷贝
const assignDeep = (target, ...args) => {
    if (isObject(target) && args.length > 0) {
        args.forEach((arg) => {
            if (isObject(arg)) {
                Object.keys(arg).forEach((key) => {
                    const oldValue = target[key];
                    const newValue = arg[key];

                    if (isObject(oldValue) && isObject(newValue)) {
                        target[key] = assignDeep({}, oldValue, newValue);
                    } else if (isObject(newValue)) {
                        target[key] = assignDeep({}, newValue);
                    } else {
                        target[key] = newValue;
                    }
                });
            }
        });
    }
    return target;
};

// ,钱格式转成数字
const formatMoneyNum = (value, decimalCount = 0) => {
    return value.split(',').join('');
};

// 数字转成,格式，且保留几位小数
const formatNumber = (value, decimalCount = 0) => {
    value = decimalCount > 0 ? Number(value).toFixed(decimalCount) : String(value);

    const [integer = '', decimal = ''] = value.split('.');
    const segments = [];
    const numerals = [];
    let i = integer.length;

    while (i > 0) {
        if (i > 3) {
            segments.unshift(integer.substr(i - 3, 3));
        } else {
            segments.unshift(integer.substr(0, i));
        }

        i -= 3;
    }

    numerals.push(segments.join(','));

    if (decimalCount > 0) {
        numerals.push(decimal);
    }

    return numerals.join('.');
};

const REGEXP_PHONE_NUMBER_GROUPS = /^(\d{3})(\d{4})(\d{4})$/;

// 手机号校验
const formatPhoneNumber = (value) => {
    return String(value).replace(REGEXP_PHONE_NUMBER_GROUPS, '$1 $2 $3');
};

// 获取随机keys
const uuid = () => {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';

    const uuid = s.join('');
    return uuid;
};

/**
 * 安全解码，避免因为传递进来的字符串不合法导致decode报错
 * @param {String} str
 * @returns {String}
 */
export function safeDecode(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        console.error(`传入的字符串无法被decode: ${str} `, err);
        return str;
    }
}

const splitSearchKeyValue = (str = '') => {
    const [key, ...valueArr] = str.split('=');
    const value = valueArr.length ? valueArr.join('=') : undefined;
    return [key, value].filter((i) => i !== undefined).map(safeDecode);
};

// 对Url进行?后解析
const query = (url = window.location.href) => {
    let search = '';
    const obj = {};
    if (typeof search !== 'string') {
        return obj;
    }
    if (url.includes('?')) {
        const a = document.createElement('a');
        a.href = url;
        search = a.search.slice(1);
    } else {
        search = '';
    }
    search.split('&').forEach((i) => {
        const [k, v] = splitSearchKeyValue(i);
        if (k) {
            obj[k] = v;
        }
    });
    return obj;
};

// 对Url进行详细解析
const urlParse = (href = window.location.href) => {
    const a = document.createElement('a');
    a.href = href;
    const queryObj = {};
    a.search
        .slice(1)
        .split('&')
        .forEach((i) => {
            const [key, value] = splitSearchKeyValue(i);
            if (value !== undefined) {
                queryObj[key] = value;
            }
        });
    return {
        query: queryObj,
        href: a.href,
        hostname: a.hostname,
        origin: a.origin,
        protocol: a.protocol,
        port: a.port,
        pathname: a.pathname,
        search: a.search,
        hash: a.hash
    };
};

/**
 * 为url添加search参数
 *
 * @param  {String} [url=''] url
 * @param  {...Object} args 多个对象
 * @returns {String} 添加参数后的url
 */
const addUrlQuery = (url = '', ...args) => {
    //  url 只能pathName 不能带参数
    // if (!/^((https?:)?\/{2}|\/[^/]*)/.test(url)) {
    //   console.error('addUrlQuery: 格式错误 url应改是以类似https:// 或者 /aa开头的字符串', url);
    // }
    // eslint-disable-next-line no-use-before-define
    const { query: queryObj } = urlParse(url);
    const obj = Object.assign(queryObj, ...args);
    const search = Object.keys(obj)
        .map((key) => [key, obj[key]].map(encodeURIComponent).join('='))
        .join('&');

    return url.replace(/(\?|#).*/, '') + (search ? `?${search}` : '');
};

// 日期格式生成
const formatDate = (fmt, date = new Date()) => {
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};

// 超过10000，转成万
const tranTenThousand = (num) => {
    if (!num) {
        return '0.00万';
    }
    return (num / 10000).toFixed(2) + '万';
};

// 节流
const throttle = (event, time) => {
    let timer = null;
    return (...args) => {
        if (!timer) {
            timer = setTimeout(() => {
                timer = null;
                event.apply(this, args);
            }, time);
        }
    };
};

// 删除对象不存在值的字段
const delNUllObj = (obj) => {
    const objCopy = deepClone(obj);
    const list = Object.getOwnPropertyNames(objCopy);
    for (const i in list) {
        if ([null, undefined].includes(objCopy[list[i]])) {
            delete objCopy[list[i]];
        }
    }
    return objCopy;
};

const debounce = (fn, delay) => {
    let time = null;// time用来控制事件的触发
    return (...args) => {
        if (time !== null) {
            clearTimeout(time);
        }
        time = setTimeout(() => {
            fn.apply(this, args);
            // 利用call(),让this的指针从指向window 转成指向input
        }, delay);
    };
};

// 统计字符长度，中文字符+2
const countStr = (str) => {
    var len = 0;
    if (str) {
        for (var i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 128) {
                len += 2;
            } else {
                len += 1;
            }
        };
    }
    return len;
};

// 获取年份列表
const getYearOptions = (pre = 2, nex = 4) => {
    const list = [{ label: '不限', value: '' }];
    const curryear = new Date().getFullYear();
    for (let i = curryear - pre; i < curryear + nex; i++) {
        list.push({ label: i, value: i, check: i === curryear });
    }
    return list;
};

// 去重
const numDedupCom = (list = [], field = 'empNo') => {
    const listSet = new Set();
    const userList = [];
    for (const item of list) {
        if (!listSet.has(item[field])) {
            listSet.add(item[field]);
            userList.push(item);
        }
    }
    return userList;
};

const getFeatureYears = (num = 4) => {
    const currentDate = new Date();
    const startD = currentDate.getFullYear();
    return Array.from({ length: num + 1 }, (_, i) => {
        return String(startD + i);
    });
};

const zeroWithTen = (num = 0) => {
    // 2位数补零
    return num < 10 ? `0${num}` : String(num);
};

const getCurrentMonthRange = () => {
    const currentDate = new Date();
    const startY = currentDate.getFullYear();
    const startM = currentDate.getMonth() + 1;
    const startD = currentDate.getDate();
    return [`${startY}-${zeroWithTen(startM)}-01`, `${startY}-${zeroWithTen(startM)}-${zeroWithTen(startD)}`];
};

const getCurrentYearRange = () => {
    const currentDate = new Date();
    const startY = currentDate.getFullYear();
    const startM = currentDate.getMonth() + 1;
    const startD = currentDate.getDate();
    return [`${startY}-01-01`, `${startY}-12-31`];
};

const unFn = (fn, ...arg) => typeof fn === 'function' ? fn(...arg) : fn;

const obj2Number = (obj = {}, keys = '') => {
    const _resObj = obj;
    const _keys = keys.split(',');
    Object.keys(obj).forEach(key => {
        if (_keys.includes(key)) {
            _resObj[key] = Number(_resObj[key]);
        }
    });
    return _resObj;
};

export {
    isObject,
    isFunction,
    handleParams, // url拼接
    deepClone, // 深拷贝
    assignDeep, // 浅拷贝
    formatMoneyNum, // ,钱格式转成数字
    formatNumber, // 数字转成,格式，且保留几位小数
    formatPhoneNumber, // 手机号校验
    uuid, // 获取随机keys
    query, // 对Url进行?后解析
    urlParse, // 对Url进行详细解析
    addUrlQuery, // 为url添加search参数
    formatDate, // 日期格式生成
    tranTenThousand, // 超过10000，转成万
    throttle, // 节流
    debounce, // 防都动画
    delNUllObj, // 删除不存在值得字段
    countStr, // 统计字符长度，中文字符
    getYearOptions, // 获取年份列表
    numDedupCom, // 去重
    getFeatureYears, // 获取未来几年的列表
    unFn,
    getCurrentMonthRange, // 获取当月第一天到今天的区间日期
    getCurrentYearRange, // // 获取本年的1月1-12月31区间日期
    obj2Number // 转换指定的key-value为数字
};
